export const STALE_FLAG_TIMEOUT = 10000; // 10 seconds - consider processing flag stale after this

export const isProcessingFlagStale = () => {
  const timestamp = localStorage.getItem('refreshTokenProcessingTimestamp');
  if (!timestamp) return true;
  return Date.now() - Number(timestamp) > STALE_FLAG_TIMEOUT;
};

export const setProcessingFlag = () => {
  localStorage.setItem('refreshTokenProcessing', 'true');
  localStorage.setItem('refreshTokenProcessingTimestamp', String(Date.now()));
};

export const clearProcessingFlag = () => {
  localStorage.removeItem('refreshTokenProcessing');
  localStorage.removeItem('refreshTokenProcessingTimestamp');
};
